import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectedDefaultTopic } from 'components/KBQSelect'

const initialState: SelectedDefaultTopic[] = []
const selectedTopic = createSlice({
  name: 'SelectedTopic',
  initialState,
  reducers: {
    setSelectedTopic(state, action: PayloadAction<SelectedDefaultTopic>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
  },
})
export const { setSelectedTopic } = selectedTopic.actions
export default selectedTopic.reducer
